export default __webpack_public_path__ + "static/media/2009.6cd55647.png";